export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 100 },
  { key: '5', headerName: 'Audit Number', field: 'audit_id', hide: false, width: 160 },
  { key: '7', headerName: 'Submission Date', field: 'created_at', hide: false, width: 200 },
  { key: '4', headerName: 'Audit Agent Name', field: 'agentName', hide: false, width: 160 },
  { key: '9', headerName: 'Waiting at', field: 'waiting', hide: false, width: 160 },
  { key: '10', headerName: 'Aging Days', field: 'agingDays', hide: false, width: 160 },
  { key: '3', headerName: 'Score', field: 'total_mark', hide: false, width: 160 },
];
